// @ts-nocheck

import { colors } from '@lmc/common/constants'
import { Icon } from '@lmc/ui-kit'
import { find } from 'lodash'
import PropTypes from 'prop-types'
import { PureComponent } from 'react'
import RiskAssessmentItem from '../../../../screens/Residents/screens/ResidentRiskAssessmentsScreens/components/RiskAssessmentItem.jsx'
import { ListItem, SearchSelect } from '../../../generic'

export default class CreateAssessmentDashboard extends PureComponent {
  handleSelect = (item) => {
    const { addExisting, addNew } = this.props
    if (this.isExisting(item)) {
      addExisting(item, this.goToNextStep)
    } else {
      addNew(item.id, item.isCustomTemplate, this.goToNextStep)
    }
  }

  goToNextStep = () => {
    if (this.props.goToNextStep) this.props.goToNextStep()
  }

  isExisting = (item) => item.form && item.form.id

  getOptionValue = (option) =>
    this.isExisting(option) ? option.form.name : option.name

  renderCustomTemplateItems = () => {
    const customTemplates = this.props.data.formsAndAssessments.filter(
      (assessment) => assessment.isCustomTemplate
    )
    if (!customTemplates.length) return null

    return (
      <div style={styles.itemsContainer}>
        <div style={styles.customTemplatesTitle}>
          Create a Customised Risk Assessment
        </div>
        {customTemplates.map((item) => (
          <ListItem
            iconText={item.iconText}
            iconColor={item.color}
            inlineChildren
            key={item.id}
            label={item.name}
            onSelect={() => this.handleSelect(item)}
            iconSize={20}
            size={40}
            style={styles.listItem}
          >
            <div style={styles.customTemplateArrow}>
              <Icon name="RightOutlined" />
            </div>
          </ListItem>
        ))}
      </div>
    )
  }

  renderListItem = (item) => (
    <div key={item.id}>
      {this.isExisting(item) ? (
        <RiskAssessmentItem
          carer={find(this.props.data.carers, { id: item.createdBy })}
          riskAssessment={item}
          onView={() => this.handleSelect(item)}
          carePlanNominative={this.props.data.carePlanNominative}
          allowRedirect={false}
        />
      ) : (
        <ListItem
          iconText={item.iconText}
          iconColor={item.color}
          label={item.name}
          onSelect={() => this.handleSelect(item)}
          subLabel="No reviews yet"
          iconSize={20}
          size={40}
        />
      )}
    </div>
  )

  render() {
    const {
      data: { carers, formsAndAssessments },
      style
    } = this.props
    if (!carers || !formsAndAssessments) return null

    const nonArchivedFormsAndAssessments = formsAndAssessments.filter(
      (forms) => !forms.archived
    )

    return (
      <div
        style={{
          ...style,
          ...styles.container
        }}
      >
        <div style={styles.titleContainer}>{TITLE}</div>
        <div style={styles.searchContainer}>
          <SearchSelect
            getOptionLabel={this.getOptionValue}
            getOptionValue={this.getOptionValue}
            options={nonArchivedFormsAndAssessments}
            placeholder="Search by name"
            onChange={this.handleSelect}
          />
        </div>
        {this.renderCustomTemplateItems()}
        <div style={styles.itemsContainer}>
          {nonArchivedFormsAndAssessments.map((item) =>
            item.isCustomTemplate ? null : this.renderListItem(item)
          )}
        </div>
      </div>
    )
  }
}

const TITLE = 'Add a Risk Assessment'

const styles = {
  cancelButton: {
    cursor: 'pointer',
    display: 'inline-block',
    position: 'absolute',
    left: 20,
    top: 20
  },
  container: {
    maxWidth: 720
  },
  customTemplateArrow: {
    alignSelf: 'center',
    fontSize: 30
  },
  customTemplatesTitle: {
    borderBottom: '1px solid',
    borderColor: colors.grey,
    fontSize: 16,
    padding: '8px 0px'
  },
  itemsContainer: {
    paddingTop: 50
  },
  helpNote: {
    color: colors.darkgrey,
    display: 'block',
    fontSize: 13,
    marginTop: 5
  },
  searchContainer: {
    paddingTop: 24
  },
  titleContainer: {
    fontWeight: 300,
    fontSize: 28,
    textAlign: 'center'
  }
}

CreateAssessmentDashboard.propTypes = {
  addExisting: PropTypes.func.isRequired,
  addNew: PropTypes.func.isRequired,
  carePlanFormData: PropTypes.object,
  data: PropTypes.shape({
    carers: PropTypes.array.isRequired,
    formsAndAssessments: PropTypes.array.isRequired
  }).isRequired
}
